import I18n from 'I18n';
export function insertChangesTab(location) {
  return Object.assign({}, location, {
    container: Object.assign({}, location.container, {
      contents: [...location.container.contents, {
        type: 'CONTAINER',
        id: '3',
        label: I18n.text('changesTab.label'),
        layout: {
          type: 'SINGLE_CARD'
        },
        containerFeatures: [],
        contents: [{
          type: 'CARD',
          layout: {
            type: 'CARD',
            widthInGrid: 12
          },
          definition: {
            cardId: 'contract-changes',
            cardType: 'CONTRACT_CHANGES'
          },
          configuration: {}
        }]
      }]
    })
  });
}